import { useMemo, useState } from 'react'

import type { DeprecationContext } from './deprecationContext'

/** Simplified deprecation handler, where the button can only be turned on (we assume properties are static) */
export const useDeprecationContext = () => {
	const [showDeprecated, setShowDeprecated] = useState(true)
	const [hasDeprecated, setHasDeprecated] = useState(false)

	return useMemo<DeprecationContext>(
		() => ({
			hasDeprecated,
			showDeprecated,
			toggleShowDeprecated: () => {
				setShowDeprecated((current) => !current)
			},
			registerDeprecated: hasDeprecated
				? () => {}
				: () => {
						setHasDeprecated(true)
					},
		}),
		[hasDeprecated, showDeprecated],
	)
}
